/* @ngInject */
function truncateText () {
  return function (input, limit) {
    if (input) {
      return input.length > limit ? `${input.substring(0, limit).trim()}...` : input
    }

    return ''
  }
}

export { truncateText }
